import { buildClasses } from "../utils/buildClasses";

/** Decorative spinner; its container supplies the accessible status message. */
export function RyeSpinner() {
  return (
    <span
      aria-hidden="true"
      className={buildClasses(
        "inline-block",
        "h-5",
        "w-5",
        "shrink-0",
        "rounded-full",
        "border-2",
        "border-purple-100",
        "border-t-purple",
        "animate-spin",
        "motion-reduce:animate-none",
      )}
    />
  );
}
